export const plotTabs = {
  overview: 'overview',
  application: 'application',
  documents: 'documents',
  discussion: 'discussion',
} as const
